<template>
  <div class="contacts" id="contacts">
    <div class="contacts__title">Контакты</div>
    <div class="contacts__elements">
      <div class="">
        <div class="contacts__name">E-mail</div>
        <div class="contacts__value">info@export-finanz.com</div>
      </div>
      <div class="">
        <div class="contacts__name">Телефон</div>
        <div class="contacts__value">+998 91 615 06 70</div>
      </div>
      <div class="">
        <div class="contacts__name">Соцсети</div>
        <div class="contacts__socials">
          <div class="contacts__icon">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 23.9859 5.85094 30.6053 13.5 31.8056V20.625H9.4375V16H13.5V12.475C13.5 8.465 15.8888 6.25 19.5434 6.25C21.2934 6.25 23.125 6.5625 23.125 6.5625V10.5H21.1075C19.12 10.5 18.5 11.7334 18.5 13V16H22.9375L22.2281 20.625H18.5V31.8056C26.1491 30.6053 32 23.9859 32 16Z"
                fill="#4A2929"
              />
              <path
                d="M22.2281 20.625L22.9375 16H18.5V13C18.5 11.7347 19.12 10.5 21.1075 10.5H23.125V6.5625C23.125 6.5625 21.2941 6.25 19.5434 6.25C15.8888 6.25 13.5 8.465 13.5 12.475V16H9.4375V20.625H13.5V31.8056C15.1566 32.0648 16.8434 32.0648 18.5 31.8056V20.625H22.2281Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="contacts__icon">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 2.88125C20.275 2.88125 20.7813 2.9 22.4625 2.975C24.025 3.04375 24.8688 3.30625 25.4313 3.525C26.175 3.8125 26.7125 4.1625 27.2688 4.71875C27.8313 5.28125 28.175 5.8125 28.4625 6.55625C28.6813 7.11875 28.9438 7.96875 29.0125 9.525C29.0875 11.2125 29.1063 11.7188 29.1063 15.9875C29.1063 20.2625 29.0875 20.7688 29.0125 22.45C28.9438 24.0125 28.6813 24.8563 28.4625 25.4188C28.175 26.1625 27.825 26.7 27.2688 27.2563C26.7063 27.8188 26.175 28.1625 25.4313 28.45C24.8688 28.6688 24.0188 28.9313 22.4625 29C20.775 29.075 20.2688 29.0938 16 29.0938C11.725 29.0938 11.2188 29.075 9.5375 29C7.975 28.9313 7.13125 28.6688 6.56875 28.45C5.825 28.1625 5.2875 27.8125 4.73125 27.2563C4.16875 26.6938 3.825 26.1625 3.5375 25.4188C3.31875 24.8563 3.05625 24.0063 2.9875 22.45C2.9125 20.7625 2.89375 20.2563 2.89375 15.9875C2.89375 11.7125 2.9125 11.2063 2.9875 9.525C3.05625 7.9625 3.31875 7.11875 3.5375 6.55625C3.825 5.8125 4.175 5.275 4.73125 4.71875C5.29375 4.15625 5.825 3.8125 6.56875 3.525C7.13125 3.30625 7.98125 3.04375 9.5375 2.975C11.2188 2.9 11.725 2.88125 16 2.88125ZM16 0C11.6563 0 11.1125 0.01875 9.40625 0.09375C7.70625 0.16875 6.5375 0.44375 5.525 0.8375C4.46875 1.25 3.575 1.79375 2.6875 2.6875C1.79375 3.575 1.25 4.46875 0.8375 5.51875C0.44375 6.5375 0.16875 7.7 0.09375 9.4C0.01875 11.1125 0 11.6562 0 16C0 20.3438 0.01875 20.8875 0.09375 22.5938C0.16875 24.2938 0.44375 25.4625 0.8375 26.475C1.25 27.5313 1.79375 28.425 2.6875 29.3125C3.575 30.2 4.46875 30.75 5.51875 31.1562C6.5375 31.55 7.7 31.825 9.4 31.9C11.1063 31.975 11.65 31.9937 15.9938 31.9937C20.3375 31.9937 20.8813 31.975 22.5875 31.9C24.2875 31.825 25.4563 31.55 26.4688 31.1562C27.5188 30.75 28.4125 30.2 29.3 29.3125C30.1875 28.425 30.7375 27.5313 31.1438 26.4813C31.5375 25.4625 31.8125 24.3 31.8875 22.6C31.9625 20.8938 31.9813 20.35 31.9813 16.0063C31.9813 11.6625 31.9625 11.1188 31.8875 9.4125C31.8125 7.7125 31.5375 6.54375 31.1438 5.53125C30.75 4.46875 30.2063 3.575 29.3125 2.6875C28.425 1.8 27.5313 1.25 26.4813 0.84375C25.4625 0.45 24.3 0.175 22.6 0.1C20.8875 0.01875 20.3438 0 16 0Z"
                fill="#4A2929"
              />
              <path
                d="M16 7.78125C11.4625 7.78125 7.78125 11.4625 7.78125 16C7.78125 20.5375 11.4625 24.2188 16 24.2188C20.5375 24.2188 24.2188 20.5375 24.2188 16C24.2188 11.4625 20.5375 7.78125 16 7.78125ZM16 21.3312C13.0563 21.3312 10.6687 18.9438 10.6687 16C10.6687 13.0563 13.0563 10.6687 16 10.6687C18.9438 10.6687 21.3312 13.0563 21.3312 16C21.3312 18.9438 18.9438 21.3312 16 21.3312Z"
                fill="#4A2929"
              />
              <path
                d="M26.4625 7.45635C26.4625 8.51885 25.6 9.3751 24.5438 9.3751C23.4813 9.3751 22.625 8.5126 22.625 7.45635C22.625 6.39385 23.4875 5.5376 24.5438 5.5376C25.6 5.5376 26.4625 6.4001 26.4625 7.45635Z"
                fill="#4A2929"
              />
            </svg>
          </div>

          <div class="contacts__icon">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                fill="#4A2929"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.24251 15.8311C11.9068 13.7989 15.0171 12.4592 16.5734 11.8119C21.0167 9.96372 21.94 9.64267 22.5418 9.63207C22.6742 9.62974 22.9701 9.66254 23.1618 9.81809C23.3237 9.94944 23.3682 10.1269 23.3895 10.2514C23.4108 10.3759 23.4374 10.6596 23.4163 10.8813C23.1755 13.4112 22.1336 19.5508 21.6036 22.3844C21.3793 23.5834 20.9376 23.9855 20.5101 24.0248C19.581 24.1103 18.8754 23.4108 17.9755 22.8208C16.5673 21.8977 15.7717 21.3231 14.4048 20.4223C12.8251 19.3813 13.8492 18.8092 14.7494 17.8741C14.985 17.6294 19.0789 13.9058 19.1581 13.568C19.168 13.5257 19.1772 13.3682 19.0837 13.2851C18.9901 13.2019 18.852 13.2304 18.7524 13.253C18.6112 13.285 16.3615 14.772 12.0035 17.7137C11.365 18.1522 10.7866 18.3659 10.2684 18.3547C9.69709 18.3423 8.59817 18.0317 7.78124 17.7661C6.77924 17.4404 5.98287 17.2682 6.05221 16.715C6.08833 16.4269 6.4851 16.1323 7.24251 15.8311Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.contacts {
  margin-bottom: 60px;
  &__title {
    font-weight: 860;
    font-size: 44px;
    line-height: 53px;
    text-align: center;
    color: #5f3b3b;
    margin-bottom: 29px;
    @media (max-width: 480px) {
      font-size: 32px;
      line-height: 38px;
      margin-bottom: 24px;
    }
  }
  &__elements {
    background: #f7f7f7;
    border-radius: 12px;
    padding: 24px 48px;
    display: grid;
    grid-column-gap: 20px;
    grid-template-columns: 1fr 307px 1fr;
    @media (max-width: 880px) {
      grid-template-columns: 1fr;
      grid-row-gap: 24px;
      padding: 32px 12px;
      grid-column-gap: 0;
    }
  }
  &__name {
    font-weight: 600;
    font-size: 28px;
    line-height: 150%;
    color: #4a2929;
    margin-bottom: 18px;
    @media (max-width: 480px) {
      font-size: 28px;
      line-height: 42%;
      margin-bottom: 24px;
    }
  }
  &__value {
    font-weight: 500;
    font-size: 24px;
    line-height: 150%;
    color: #4a2929;
    @media (max-width: 480px) {
      font-size: 22px;
      line-height: 36%;
      margin-bottom: 24px;
    }
  }
  &__socials {
    display: grid;
    grid-column-gap: 32px;
    grid-template-columns: repeat(3, 32px);
  }
  &__icon {
    svg {
      width: 32px;
    }
  }
}
</style>
